import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { EditorData } from "../../state/GeoGroups/EditorData";

const updateGeoGroupsEditorData: Reducer<EditorData> = (state: EditorData = new EditorData(), action: Action<ActionType, EditorData>) => {
  switch (action.type) {
    case ActionType.GEO_GROUPS_EDITOR_DATA_RESET:
      return new EditorData();
    case ActionType.GEO_GROUPS_EDITOR_DATA_FETCHED:
      return { ...state, geoGroupsEditorData: action.data };
    case ActionType.GEO_GROUPS_EDITOR_DATA_COPIED:
      return { ...state, geoGroupsEditorData: { ...action.data} };
    case ActionType.GEO_GROUPS_EDITOR_DATA_UPDATED:
      return { ...state, geoGroupsEditorData: { ...state.geoGroupsEditorData, ...action.data } };
    case ActionType.GEO_GROUPS_EDITOR_DATA_SAVED:
      return { ...state, readyToSave: false };
    case ActionType.GEO_GROUPS_EDITOR_DATA_VALIDATED:
      return { ...state, validation: {...action.data }};
    case ActionType.GEO_GROUPS_EDITOR_SET_BOUND_ITEM:
      return {...state, geoGroupsEditorData: {...state.geoGroupsEditorData, ...action.data}}
    default:
      return state;
  }
};

export default updateGeoGroupsEditorData;
